export default "__VITE_ASSET__fe690d11__"